module.exports = {
  BASE_URL: 'https://api.hoisomb-tieudung.com/api/v1',
  SOCKET_SERVER_URL: 'https://api.hoisomb-tieudung.com',
  // BASE_URL: 'http://localhost:8082/api/v1',
  // SOCKET_SERVER_URL: 'http://192.168.35.109:8082'
};
